// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import employees from '../views/pages/employees/store'
import employee from '../views/pages/employee/store'
import salaries from '../views/pages/salaries/store'
import rates from '../views/pages/rates/store'
import rateCard from '../views/pages/rate-card/store'
import salaryReviews from '../views/pages/salary-reviews/store'
import employeeMargin from '../views/pages/employee-margin/store'
import timeCostAudit from '../views/pages/time-cost-audit/store'
import monthlyPayments from '../views/pages/monthly-payments/store'
import invoices from '../views/pages/invoices/store'
import entities from '../views/pages/entities/store'
import customersSettings from '../views/pages/customers/store'
import marginAnalysis from './marginAnalysis/marginAnalysisSlice'
import userCustomerAccess from '../views/pages/user-customer-access/store'
import spendTracking from './spendTracking/spendTrackingSlice'
import notificationPreferences from './notificationPreferences/notificationPreferencesSlice'
import customerLinks from './customerLinks/customerLinksSlice'
import pnlReport from './pnlReport/pnlReportSlice'
import salaryCalculation from './salaryCalculation/salaryCalculationSlice'
import keyMetrics from './keyMetrics/keyMetricsSlice'
import surveys from './surveys/surveysSlice'
import currentUser from './currentUser/currentUserSlice'

const rootReducer = {
  layout,
  navbar,
  employees,
  employee,
  salaries,
  rates,
  rateCard,
  salaryReviews,
  employeeMargin,
  timeCostAudit,
  monthlyPayments,
  invoices,
  entities,
  customersSettings,
  marginAnalysis,
  userCustomerAccess,
  spendTracking,
  notificationPreferences,
  customerLinks,
  pnlReport,
  salaryCalculation,
  keyMetrics,
  surveys,
  currentUser
}

export default rootReducer
